import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询政策分页
  getPolicyInterpretationPage: `${baseUrl}/yqPolicyInterpretation/getPage`,

  // 添加政策
  addPolicyInterpretation: `${baseUrl}/yqPolicyInterpretation/add`,

  // 查询政策
  getPolicyInterpretationByCode: `${baseUrl}/yqPolicyInterpretation/getByCode`,

  // 修改政策
  updatePolicyInterpretation: `${baseUrl}/yqPolicyInterpretation/update`,

  // 删除政策
  deletePolicyInterpretationByCodes: `${baseUrl}/yqPolicyInterpretation/deleteByCodes`,

  // 查询党群资讯分页
  getPartyBuildingInformationPage: `${baseUrl}/yqPartyBuildingInformation/getPage`,

  // 添加党群资讯
  addPartyBuildingInformation: `${baseUrl}/yqPartyBuildingInformation/add`,

  // 查询党群资讯
  getPartyBuildingInformationByCode: `${baseUrl}/yqPartyBuildingInformation/getByCode`,

  // 修改党群资讯
  updatePartyBuildingInformation: `${baseUrl}/yqPartyBuildingInformation/update`,

  // 删除党群资讯
  deletePartyBuildingInformationByCodes: `${baseUrl}/yqPartyBuildingInformation/deleteByCodes`,

  // 上传图片
  uploadImg: `${baseUrl}/yqNews/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/yqParty.js